import pckg from '../../package.json';

export const localeConfig = {
	defaultLanguage: 'en-US',
	defaultNS: pckg.translations.namespaces[0],
	ns: pckg.translations.namespaces,
};

export default localeConfig;
